/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, June 29th 2022, 3:15:44 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { DnDItemTypes } from "config";
import { COLORSCHEME } from "theme/styles";
import { GenericDragSource } from "ui-widgets/drag-and-drop";
import { BPMNTaskTypeIcon } from "service-builder/components/workflow-builder/TaskTemplateIcons";
import { ToolBarItemButton } from "common/components/toolbar";
import { NODE_TYPE_WIDGETS } from "./TaskTypeWidgets";
import { INodeTypeDnDSelectorState } from "./types";

export const BPMNDraggableNodeTypeIcon = ({ taskType }) => (
  <BPMNTaskTypeIcon taskType={taskType} color={COLORSCHEME.secondary} fontSize={40} />
);

interface BPMNDraggableNodeTypeButtonProps extends INodeTypeDnDSelectorState {
  typeTitle: React.ReactNode;
  tooltipText: React.ReactNode;
}

export const BPMNDraggableNodeTypeButton = ({
  typeTitle,
  tooltipText,
  newNodeType,
  newNodeTitle,
}: BPMNDraggableNodeTypeButtonProps) => {
  return (
    <GenericDragSource<INodeTypeDnDSelectorState>
      itemType={DnDItemTypes.OS_ADD_NEW_TASK_TEMPLATE}
      dragItemState={{ newNodeType, newNodeTitle }}
      hideDefaultDragPreview
    >
      <div className={NODE_TYPE_WIDGETS[newNodeType]?.nodeTypeCssClassName}>
        <ToolBarItemButton
          tooltipText={tooltipText}
          buttonIcon={<BPMNDraggableNodeTypeIcon taskType={newNodeType} />}
          buttonTitle={typeTitle}
        />
      </div>
    </GenericDragSource>
  );
};
